<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';

const { t } = useI18n();

const successMode = defineModel('successMode', {
  type: String,
  default: 'message',
});
const successMessage = defineModel('successMessage', {
  type: String,
  default: '',
});
const redirectUrl = defineModel('redirectUrl', { type: String, default: '' });

// The success-screen title (theme.success_title) rides inside the shared
// theme JSONB, same "no migration" trick as theme.welcome — so this editor
// also takes the theme object as its default (unnamed) v-model, alongside
// the three named models above for the form's own success_mode/message/
// redirect_url columns.
const theme = defineModel({ type: Object, required: true });

const successTitle = computed(() => theme.value.success_title || '');

const updateSuccessTitle = value => {
  theme.value = { ...theme.value, success_title: value };
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1">
      <h3 class="text-base font-semibold text-n-slate-12">
        {{ t('FORMS_MGMT.EDITOR.SUCCESS.TITLE') }}
      </h3>
      <p class="text-sm text-n-slate-11">
        {{ t('FORMS_MGMT.EDITOR.SUCCESS.DESCRIPTION') }}
      </p>
    </div>

    <Input
      :model-value="successTitle"
      :label="t('FORMS_MGMT.EDITOR.SUCCESS.HEADLINE_LABEL')"
      :placeholder="t('FORMS_MGMT.EDITOR.SUCCESS.HEADLINE_PLACEHOLDER')"
      @update:model-value="updateSuccessTitle"
    />

    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium text-n-slate-12">
        {{ t('FORMS_MGMT.EDITOR.SUCCESS.MODE') }}
      </span>
      <select v-model="successMode" class="form-select w-fit">
        <option value="message">
          {{ t('FORMS_MGMT.EDITOR.SUCCESS.MODE_MESSAGE') }}
        </option>
        <option value="redirect">
          {{ t('FORMS_MGMT.EDITOR.SUCCESS.MODE_REDIRECT') }}
        </option>
      </select>
    </label>

    <label v-if="successMode === 'message'" class="flex flex-col gap-1">
      <span class="text-sm font-medium text-n-slate-12">
        {{ t('FORMS_MGMT.EDITOR.SUCCESS.MESSAGE_LABEL') }}
      </span>
      <textarea
        v-model="successMessage"
        rows="3"
        class="form-textarea"
        :placeholder="t('FORMS_MGMT.EDITOR.SUCCESS.MESSAGE_PLACEHOLDER')"
      />
    </label>

    <Input
      v-else
      v-model="redirectUrl"
      :label="t('FORMS_MGMT.EDITOR.SUCCESS.REDIRECT_LABEL')"
      :placeholder="t('FORMS_MGMT.EDITOR.SUCCESS.REDIRECT_PLACEHOLDER')"
    />
  </div>
</template>
